import { Box, Button, Modal, Text, styled } from '@/theme/index';

export const StyledTopBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.grey[800],
  color: '#fff',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  height: '50px',
}));

export const StyledCloseButton = styled(Button)({
  position: 'absolute',
  left: 0,
  top: '50%',
  zIndex: 2,
  transform: 'translateY(-50%)',
  color: '#fff',
});

export const StyledText = styled(Text)({
  position: 'absolute',
  width: '100%',
  textAlign: 'center',
  alignSelf: 'center',
  zIndex: 1,
});

export const StyledModal = styled(Modal)({
  '.MuiDialogContent-root': {
    padding: 0,
    margin: 0,
    overflow: 'hidden',
  },
  height: '90vh',
  padding: 0,
  margin: 0,
  '.MuiPaper-elevation': {
    height: '100%',
    width: '100%',
  },
});

export const StyledVideoImageContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const StyledCaptureContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '30%',
  height: '40%',
  width: '100%',
});

export const StyledCaptureBox = styled(Box)({
  height: '100%',
  width: '90%',
  border: '4px solid #FF4722',
  borderRadius: '20px',
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0px 0px 0px 1000px rgba(0, 0, 0, 0.5)',
});

export const StyledButtonContainer = styled(Box)({
  position: 'absolute',
  bottom: '30px',
  width: '90%',
  backgroundColor: 'rgba(0,0,0,0.5)',
});

export const StyledCameraContainer = styled(Box)({
  height: '100%',
  width: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  position: 'relative',
  overflow: 'hidden',
});

export const StyledCircularProgress = styled(Box)(({ theme }) => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  display: 'flex',
  zIndex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0,0,0,0.5)',

  '& .MuiCircularProgress-root': {
    width: '100px',
    color: theme.palette.grey[100],
  },
}));
